import { useCallback, useState } from "react";
import { Button, Input, Typography } from "antd";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../configureStore";
import { verifyLast4Tin } from "../../redux/reducer/applicant";

interface TinGateProps {
    institutionId: string;
    applicantId: string;
    onVerified: () => void;
}

const TinGate = ({ institutionId, applicantId, onVerified }: TinGateProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [tinInput, setTinInput] = useState<string>('');
    const [tinError, setTinError] = useState<string>('');
    const [tinLoading, setTinLoading] = useState<boolean>(false);

    const handleVerify = useCallback(() => {
        if (tinInput.length !== 4) return;
        setTinLoading(true);
        setTinError('');
        dispatch(verifyLast4Tin({
            input: { institutionId, applicantId, last4Tin: tinInput },
            onSuccess: () => {
                setTinLoading(false);
                onVerified();
            },
            onFailure: () => {
                setTinError('The digits entered do not match. Please try again.');
                setTinLoading(false);
            },
        }));
    }, [dispatch, institutionId, applicantId, tinInput, onVerified]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 128px)' }}>
            <div style={{ textAlign: 'center', padding: '48px', background: 'white', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', maxWidth: 400, width: '100%' }}>
                <Typography.Title level={4}>Identity Verification</Typography.Title>
                <Typography.Text style={{ display: 'block', marginBottom: 24 }}>
                    Please enter the last 4 digits of your TIN to continue.
                </Typography.Text>
                <Input
                    maxLength={4}
                    value={tinInput}
                    onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '');
                        setTinInput(val);
                        setTinError('');
                    }}
                    onPressEnter={handleVerify}
                    placeholder="0000"
                    style={{ width: 160, textAlign: 'center', fontSize: 24, letterSpacing: 8, marginBottom: 8, paddingLeft: 8 }}
                    status={tinError ? 'error' : undefined}
                />
                {tinError && (
                    <Typography.Text type="danger" style={{ display: 'block', marginBottom: 16 }}>
                        {tinError}
                    </Typography.Text>
                )}
                <div style={{ marginTop: 16 }}>
                    <Button
                        type="primary"
                        size="large"
                        loading={tinLoading}
                        disabled={tinInput.length !== 4}
                        onClick={handleVerify}
                    >
                        Verify
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default TinGate;
